import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  movieWatchContainer: {
    width: '100%',
  },
  movieWatchIframeContainer: {
    position: 'relative',
    padding: '56.25% 0 0 0',
  },
}));
